import { HttpErrorResponse } from '@angular/common/http';
import { ExtendedAttributeFilterInterface } from 'app/library/all-users/interfaces/extended-attribute-filer.interface';
import { ICreateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/create-entity-failure-payload.interface';
import { IFetchEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/fetch-entity-failure-payload.interface';
import { IUpdateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/update-entity-failure-payload.interface';
import { IChangeCourseOfferingCategoryActionPayload } from '../interfaces/change-course-offering-category.action.payload.interface';
import { ICreateOfferingActionPayload } from '../interfaces/create-offering.action.payload.interface';
import { ICreateProgramOfferingActionPayload } from '../interfaces/create-program-offering.action.payload.interface';
import { IDeleteCourseOfferingResult } from '../interfaces/delete-course-offering-result.interface';
import { CourseOfferingsByCategory } from '../models/course-offering-by-group.model';
import { CourseOfferingWithBreadcrumb } from '../models/course-offering-with-breadcrumb.model';
import { CourseOffering } from '../models/course-offering.model';

export class SetCourseOffering {
    static readonly type = '[CourseOffering] SetCourseOffering';

    constructor(public payload: CourseOffering) {}
}

export class UnsetCourseOffering {
    static readonly type = '[CourseOffering] UnsetCourseOffering';
}

export class FetchCourseOffering {
    static readonly type = '[CourseOffering] FetchCourseOffering';

    constructor(public payload: string) {}
}

export class FetchCourseOfferingSuccess {
    static readonly type = '[CourseOffering] FetchCourseOfferingSuccess';

    constructor(public payload: CourseOffering) {}
}

export class FetchCourseOfferingFailure {
    static readonly type = '[CourseOffering] FetchCourseOfferingFailure';

    constructor(public payload: IFetchEntityFailureActionPayload) {}
}

export class CreateCourseOffering {
    static readonly type = '[CourseOffering] CreateCourseOffering';

    constructor(public payload: ICreateOfferingActionPayload) {}
}

export class CreateCourseOfferingSuccess {
    static readonly type = '[CourseOffering] CreateCourseOfferingSuccess';

    constructor(public payload: CourseOffering) {}
}

export class CreateCourseOfferingFailure {
    static readonly type = '[CourseOffering] CreateCourseOfferingFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}

export class UpdateOffering {
    static readonly type = '[CourseOffering] UpdateOffering';

    constructor(public payload: CourseOffering) {}
}

export class UpdateOfferingSuccess {
    static readonly type = '[CourseOffering] UpdateOfferingSuccess';

    constructor(public payload: CourseOffering) {}
}

export class UpdateOfferingFailure {
    static readonly type = '[CourseOffering] UpdateOfferingFailure';

    constructor(public payload: IUpdateEntityFailureActionPayload) {}
}

export class UpdateProgramOfferingCompletion {
    static readonly type = '[CourseOffering] UpdateProgramOfferingCompletion';

    constructor(public payload: CourseOffering) {}
}

export class UpdateProgramOfferingCompletionSuccess {
    static readonly type = '[CourseOffering] UpdateProgramOfferingCompletionSuccess';

    constructor(public payload: CourseOffering) {}
}

export class UpdateProgramOfferingCompletionFailure {
    static readonly type = '[CourseOffering] UpdateProgramOfferingCompletionFailure';

    constructor(public payload: IUpdateEntityFailureActionPayload) {}
}

export class DeleteCourseOffering {
    static readonly type = '[CourseOffering] DeleteCourseOffering';

    constructor(public payload: string) {}
}

export class DeleteCourseOfferingSuccess {
    static readonly type = '[CourseOffering] DeleteCourseOfferingSuccess';

    constructor(public payload: IDeleteCourseOfferingResult) {}
}

export class DeleteCourseOfferingFailure {
    static readonly type = '[CourseOffering] DeleteCourseOfferingFailure';

    constructor(public payload: string) {}
}

export class SetCourseOfferings {
    static readonly type = '[CourseOffering] SetCourseOfferings';

    constructor(public payload: CourseOffering[]) {}
}

export class SearchCourseOfferings {
    static readonly type = '[CourseOffering] SearchCourseOfferings';

    constructor(public payload: string) {}
}

export class UpdateOfferingCategory {
    static readonly type = '[CourseOffering] UpdateOfferingCategory';

    constructor(public payload: IChangeCourseOfferingCategoryActionPayload) {}
}
export class UpdateOfferingCategorySuccess {
    static readonly type = '[CourseOffering] UpdateOfferingCategorySuccess';

    constructor(public payload: CourseOffering) {}
}

export class UpdateOfferingCategoryFailure {
    static readonly type = '[CourseOffering] UpdateOfferingCategoryFailure';
}

export class FetchCourseOfferingsByCategory {
    static readonly type = '[CourseOffering] FetchCourseOfferingsByCategory';

    constructor(
        public payload: {
            categoryId: string;
            searchTerm: string;
            courseOfferingType: number;
            tags?: string[];
            types?: string[];
            extendedAttributesFilters?: ExtendedAttributeFilterInterface[];
        }
    ) {}
}

export class FetchCourseOfferingsByCategorySuccess {
    static readonly type = '[CourseOffering] FetchCourseOfferingsByCategorySuccess';

    constructor(public payload: CourseOfferingsByCategory[]) {}
}

export class FetchCourseOfferingsByCategoryFailure {
    static readonly type = '[CourseOffering] FetchCourseOfferingsByCategoryFailure';
}

export class SearchCourseOfferingsByCategory {
    static readonly type = '[CourseOffering] SearchCourseOfferingsByCategory';

    constructor(
        public payload: {
            categoryId: string;
            searchTerm: string;
            tags?: string[];
            types?: string[];
            extendedAttributesFilters?: ExtendedAttributeFilterInterface[];
            columns?: string[];
        }
    ) {}
}

export class SearchCourseOfferingsByCategorySuccess {
    static readonly type = '[CourseOffering] SearchCourseOfferingsByCategorySuccess';

    constructor(public payload: CourseOfferingWithBreadcrumb[]) {}
}

export class SearchCourseOfferingsByCategoryFailure {
    static readonly type = '[CourseOffering] SearchCourseOfferingsByCategoryFailure';
}

export class FetchAssignedCertificates {
    static readonly type = '[CourseOffering] FetchAssignedCertificates';

    constructor(
        public payload?: {
            courseOfferingId: string;
        }
    ) {}
}

export class FetchAssignedCertificatesSuccess {
    static readonly type = '[CourseOffering] FetchAssignedCertificatesSuccess';

    constructor(public payload: { name: string }[]) {}
}

export class FetchAssignedCertificatesFailure {
    static readonly type = '[CourseOffering] FetchAssignedCertificatesFailure';

    constructor(
        public payload: {
            response: HttpErrorResponse;
        }
    ) {}
}

export class LinkAndUnlinkAudiences {
    static readonly type = '[CourseOffering] LinkAndUnlinkAudiences';

    constructor(
        public payload?: {
            courseOfferingId: string;
            linkedAudiences: { id: string }[];
            removeUsers?: boolean;
        }
    ) {}
}

export class LinkAndUnlinkAudiencesSuccess {
    static readonly type = '[CourseOffering] LinkAndUnlinkAudiencesSuccess';

    constructor(public payload: CourseOffering) {}
}

export class LinkAndUnlinkAudiencesFailure {
    static readonly type = '[CourseOffering] LinkAndUnlinkAudiencesFailure';

    constructor(
        public payload: {
            response: HttpErrorResponse;
        }
    ) {}
}

export class CreateProgramOffering {
    static readonly type = '[CourseOffering] CreateProgramOffering';

    constructor(public payload: ICreateProgramOfferingActionPayload) {}
}

export class CreateProgramOfferingSuccess {
    static readonly type = '[CourseOffering] CreateProgramOfferingSuccess';

    constructor(public payload: CourseOffering) {}
}

export class CreateProgramOfferingFailure {
    static readonly type = '[CourseOffering] CreateProgramOfferingFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}

export class CopyToOfferingCategory {
    static readonly type = '[CourseOffering] CopyToOfferingCategory';

    constructor(
        public payload: {
            courseOfferingId: string;
            targetCategoryId: string;
        }
    ) {}
}

export class CopyToOfferingCategorySuccess {
    static readonly type = '[CourseOffering] CopyToOfferingCategorySuccess';

    constructor(
        public payload: {
            id: string;
            asyncJobId: string;
        }
    ) {}
}

export class CopyToOfferingCategoryFailure {
    static readonly type = '[CourseOffering] CopyToOfferingCategoryFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}

export class UpdateOfferingOrder {
    static readonly type = '[CourseOffering] UpdateOfferingOrder';

    constructor(public payload: CourseOffering) {}
}

export class UpdateOfferingOrderSuccess {
    static readonly type = '[CourseOffering] UpdateOfferingOrderSuccess';

    constructor(public payload: CourseOffering) {}
}

export class UpdateOfferingOrderFailure {
    static readonly type = '[CourseOffering] UpdateOfferingOrderFailure';

    constructor(public payload: IUpdateEntityFailureActionPayload) {}
}
